import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnualLeaseService } from '@app/landowner-admin-shared/services/annual-lease.service';
import AnnualLease from '@app/models/annual-lease';
import PagedResults from '@app/models/paged-results';
import SeasonLookupViewModel from '@app/models/season-lookup-view-model';
import {
  AppSettingsService,
  ArrayService,
  DateService,
  ErrorHelperService,
  ListingService,
  LogService,
  NotificationService,
  RouteHelperService,
  UserService,
  ValueService,
} from '@app/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AutoCompleteDropDownComponent } from '../../../common-components/auto-complete-drop-down/auto-complete-drop-down.component';

@Component({
    selector: "season-lookup-picker",
    templateUrl: "./season-lookup-picker.component.html",
    styleUrls: ["./season-lookup-picker.component.less"],
    imports: [AutoCompleteDropDownComponent]
})
export class SeasonLookupPickerComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'SeasonLookupPickerComponent';
  private pagedResult: PagedResults;
  private _lease: AnnualLease;
  private _filteredItems: SeasonLookupViewModel[] = [];
  private _placeholder: string;
  /**
   * Subject to control observable completion
   */
  private unSubSub$ = new Subject<void>();

  public items: SeasonLookupViewModel[] = [];

  public retrieving = false;

  /**
   * Search Text
   */
  public searchText: string;

  @Output()
  public selectChange = new EventEmitter<SeasonLookupViewModel>();

  @Output()
  public selected = new EventEmitter<SeasonLookupViewModel>();

  constructor(
    private log: LogService,
    private notify: NotificationService,
    private listingService: ListingService,
    private dateService: DateService,
    private valueService: ValueService,
    private arrayService: ArrayService,
    private appSettings: AppSettingsService,
    private userService: UserService,
    private router: Router,
    private routeHelper: RouteHelperService,
    private route: ActivatedRoute,
    private errorHelper: ErrorHelperService,
    private annualLeaseService: AnnualLeaseService
  ) {}

  ngOnInit() {}

  public get filteredItems(): SeasonLookupViewModel[] {
    return this._filteredItems;
  }
  public set filteredItems(v: SeasonLookupViewModel[]) {
    console.log(`${this._componentName}.filteredItems - set - 39db7 -  v=`, v);
    this._filteredItems = v;
  }

  public get lease(): AnnualLease {
    return this._lease;
  }

  @Input()
  public set lease(v: AnnualLease) {
    console.log(`${this._componentName}.lease - set - 39db7 -  v=`, v);
    this._lease = v;

    this.retrieve();
  }

  public get placeholder(): string {
    return this._placeholder;
  }
  @Input()
  public set placeholder(v: string) {
    this._placeholder = v;
    console.log(`${this._componentName}.placeholder - set - 39db7 -  v=`, v);
  }

  /**
   * Retrieves season lookup data from the  Web API
   */
  public retrieve() {
    console.log(`${this._componentName}.retrieve()- 39db7`);

    if (!this.lease) return;

    this.retrieving = true;

    this.annualLeaseService
      .getSeasonLookup(this.lease.secureAlternateId, this.lease.listingId)
      .pipe(takeUntil(this.unSubSub$))
      .subscribe(
        (result) => {
          console.log(`${this._componentName}.retrieve() - getStateSeasonLookups subscription - 39db7 - result=`, result);

          this.items = result;
          this.retrieving = false;
        },
        (err) => {
          console.error(err);

          const msg = this.errorHelper.getErrorMessage(err) || 'A subscription error occured';

          console.error(msg);

          
          this.notify.error(msg, null);

          this.retrieving = false;
        }
      );
  }

  ngOnDestroy(): void {
    this.unSubSub$.next(void 0);
    this.unSubSub$.complete();
  }

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  public onSelectedChange(r: SeasonLookupViewModel, evt: any) {
    console.log(`${this._componentName}.onSelectedChange - 39db7 - r,evt`, r, evt);
    this.selectChange.emit(r);
  }

  public onRowClick(r: SeasonLookupViewModel) {}

  public onSelectAllClick() {
    this.items.forEach((x) => {
      x.selected = true;
      this.selectChange.emit(x);
    });
  }
  public onSelectNoneClick() {
    this.items.forEach((x) => {
      x.selected = false;
      this.selectChange.emit(x);
    });
  }

  public onSearchTextChange(searchTerm: string) {
    console.log(`${this._componentName}.onSearchTextChange searchTerm=`, searchTerm);

    this.filterItems(searchTerm);
  }
  private filterItems(searchTerm: string) {
    if (!searchTerm) {
      this.filteredItems = this.items;
    }

    this.filteredItems = this.items.filter((x) => {
      if (x.name.toLocaleLowerCase().includes(searchTerm.toLowerCase())) {
        return x;
      }

      if (x.description && x.description.toLocaleLowerCase().includes(searchTerm.toLowerCase())) {
        return x;
      }
    });
  }

  public onAddSeasonLookupToLease(item: SeasonLookupViewModel) {
    console.log(`${this._componentName}.onAddSeasonLookupToLease item=`, item);
  }

  public onSeasonLookupSelected(item: unknown) {
    const x = item as SeasonLookupViewModel;

    console.log(`${this._componentName}.onSeasonLookupSelected x=`, x);

    this.selected.emit(x);
  }
}
